import type { ListReportsParams } from 'features/yieldbirdWrapperAgent/api/types'

export const toListReportsPaging = ({
  page,
  rowsPerPage,
}: {
  page: number
  rowsPerPage: number
}): Pick<ListReportsParams, 'limit' | 'offset'> => ({
  limit: rowsPerPage,
  offset: (page - 1) * rowsPerPage,
})
